var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardLeftOrenge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 17.5C0 7.83502 7.83502 0 17.5 0V0C27.165 0 35 7.83502 35 17.5V35H17.5C7.83502 35 0 27.165 0 17.5V17.5Z",
    fill: "#C2B58C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8237 9.67569C22.2793 10.1313 22.2793 10.87 21.8237 11.3256L15.6486 17.5007L21.8237 23.6757C22.2793 24.1313 22.2793 24.87 21.8237 25.3256C21.368 25.7812 20.6294 25.7812 20.1737 25.3256L13.1737 18.3256C12.7181 17.87 12.7181 17.1313 13.1737 16.6757L20.1737 9.67569C20.6294 9.22008 21.368 9.22008 21.8237 9.67569Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardLeftOrenge);
export default __webpack_public_path__ + "static/media/dashboard-left-orenge.613180fefbaad3beb7ad30c7654ea5e3.svg";
export { ForwardRef as ReactComponent };